(ns ui.view.entity-creator.opportunity.sub
  (:require
   [common.schema.entity-creator.utils :as ecu]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]
   [reagent.ratom :as ratom]
   [ui.state.session.sub :as session-sub]
   [ui.view.entity-creator.opportunity.model :as m]))

(rf/reg-sub
 ;; Shouldn't be used directly - ident needed
 m/root-state
 (fn [db _]
   (get db m/root)))

(rf/reg-sub
 ;; State specific to a single instance of creator
 m/state
 (fn [[_ _args]]
   {:root-state (rf/subscribe [m/root-state])})
 (fn [{:keys [root-state]}
      [_ {:keys [ident]}]]
   (get-in root-state ident)))

(rf/reg-sub
 m/pipeline
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/pipeline-key)))

(rf/reg-sub
 m/processing?
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/processing-key)))

(rf/reg-sub
 m/entity-type
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/entity-type-key)))

(rf/reg-sub
 m/target-creator-type
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/target-creator-type-key)))

(rf/reg-sub
 m/creator-previous-target
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/creator-previous-target-key)))

(rf/reg-sub
 m/creator-previous-target-profile
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/creator-previous-target-profile-key)))

(rf/reg-sub
 m/associations-target-type
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/associations-target-type-key :NOT-SET)))

(rf/reg-sub
 m/stage
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/stage-key)))

(rf/reg-sub
 m/stage-id
 (fn [[_ args]]
   {:stage (rf/subscribe [m/stage args])})
 (fn [{:keys [stage]} _]
   (:db/id stage)))

(defn selected-target
  [{:keys [state]}]
  (get state m/selected-target-key))

(rf/reg-sub
 m/selected-target
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'selected-target)

(rf/reg-sub-raw
 m/target-profile
 (fn [_ [_ args]]
   (ratom/reaction
    (let [pipeline @(rf/subscribe [m/pipeline args])
          entity-type @(rf/subscribe [m/entity-type args])
          target @(rf/subscribe [m/selected-target args])
          target-type (:entity/type target)
          target-profile? (ecu/target-profile?
                           {:pipeline pipeline
                            :entity-type entity-type
                            :target-type target-type})
          target-id (:db/id target)]
      (when (and target-profile?
                 (number? target-id))
        (->> @session/investors
             (cu/find-first-by :investor/legal-entity target-id)))))))

(defn nested-on-ok
  [{:keys [state]}]
  (get state m/nested-on-ok-key))

(rf/reg-sub
 m/nested-on-ok
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'nested-on-ok)

(rf/reg-sub
 m/target-type
 (fn [[_ args]]
   {:selected-target (rf/subscribe [m/selected-target args])})
 (fn [{:keys [selected-target]}]
   (:entity/type selected-target)))

(defn current-view
  [{:keys [state]}]
  (get state m/current-view-key))

(rf/reg-sub
 m/current-view
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'current-view)

(defn initial-target-value
  [{:keys [state]}]
  (get state m/initial-target-value-key))

(rf/reg-sub
 m/initial-target-value
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'initial-target-value)

(defn target-locked?
  [{:keys [state]}]
  (get state m/target-locked?-key))

(rf/reg-sub
 m/target-locked?
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'target-locked?)

(defn open-entity-fn
  [{:keys [state]}]
  (get state m/open-entity-fn-key))

(rf/reg-sub
 m/open-entity-fn
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'open-entity-fn)

(defn associations-edits
  [{:keys [state]}]
  (get state m/associations-edits-key))

(rf/reg-sub
 m/associations-edits
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 #'associations-edits)

(defn associations-config
  [{:keys [pipeline tenant entity-type target-type]}]
  (let [stages (->> (session/pipeline-stages pipeline)
                    (sort-by :common/ord))
        full-config (if pipeline
                      (:pipeline/creator-config pipeline)
                      (:tenant/entity-creation-config tenant))
        config-path (:associations-config-path
                     (ecu/resolve-config-paths
                      {:entity-type entity-type
                       :target-type target-type
                       :pipeline pipeline}))
        raw-config (get-in full-config config-path)
        associations-config (ecu/resolve-associations-stage-config
                             {:config raw-config
                              :stages stages})]
    associations-config))

(rf/reg-sub
 m/associations-config
 (fn [[_ args]]
   {:pipeline (rf/subscribe [m/pipeline args])
    :tenant (rf/subscribe [::session-sub/tenant])
    :target-type (rf/subscribe [m/target-type args])
    :entity-type (rf/subscribe [m/entity-type args])})
 #'associations-config)

(defn main-entity-config
  [{:keys [pipeline tenant entity-type target-type system-mandatory]}]
  (let [stages (->> (session/pipeline-stages pipeline)
                    (sort-by :common/ord))
        full-config (if pipeline
                      (:pipeline/creator-config pipeline)
                      (:tenant/entity-creation-config tenant))
        config-path (:main-config-path
                     (ecu/resolve-config-paths
                      {:entity-type entity-type
                       :target-type target-type
                       :pipeline pipeline}))
        config (get-in full-config config-path)
        fields-config (ecu/resolve-fields-stage-config
                       {:config config
                        :system-mandatory system-mandatory
                        :stages stages})]
    fields-config))

(rf/reg-sub
 m/main-entity-config
 (fn [[_ args]]
   {:pipeline (rf/subscribe [m/pipeline args])
    :tenant (rf/subscribe [::session-sub/tenant])
    :target-type (rf/subscribe [m/target-type args])
    :entity-type (rf/subscribe [m/entity-type args])})
 #'main-entity-config)

(defn subview
  [{:keys [current-view]}]
  (or current-view :select-target-entity))

(rf/reg-sub
 m/subview
 (fn [[_ args]]
   {:current-view (rf/subscribe [m/current-view args])})
 #'subview)
